import React, { useEffect, useState } from 'react';
import { Button } from '../common/Button';
import * as api from '../../api/user-app-api'; // ✅ using your existing API setup

export const ContactScreen = ({ setView, params }) => {
    const [formData, setFormData] = useState({
        name: '',
        phone: '',
        email: '',
        subject: params?.orderId ? `Help with Order #${params.orderId.slice(-6)}` : '',
        message: ''
    });

    const [isSubmitting, setIsSubmitting] = useState(false);
    const [error, setError] = useState(null);
    const [submitted, setSubmitted] = useState(false);
    const [contact, setContact] = useState(null);
    const [logoLoading, setLogoLoading] = useState(true);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };
    useEffect(() => {
        const fetchLogo = async () => {
            try {
                setLogoLoading(true);
                const res = await api.fetchSettings();
                if (res.data && res.data.contact_number) {
                    setContact(res.data.contact_number);
                }
            } catch (e) {
                console.error('Failed to fetch logo:', e);
            } finally {
                setLogoLoading(false);
            }
        };
        fetchLogo();
    }, []);
    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setError(null);

        try {
            const res = await api.submitContact(formData);

            if (res.data.status === "success") {
                setSubmitted(true);
            } else {
                setError(res.data.message || "Something went wrong.");
            }
        } catch (err) {
            console.error("Error submitting support form:", err);
            setError("Failed to submit form. Please try again later.");
        } finally {
            setIsSubmitting(false);
        }
    };

    if (submitted) {
        return (
            <div className="p-4 pt-0 text-center">
                <div className="mt-8 mb-8">
                    <div className="w-16 h-16 mx-auto bg-[#01a499]/10 rounded-full flex items-center justify-center">
                        <span className="text-2xl text-[#01a499]">✓</span>
                    </div>
                    <h2 className="text-xl font-bold text-gray-800 mt-4 mb-2">
                        Message Sent Successfully
                    </h2>
                    <p className="text-gray-600 mb-8">
                        We'll get back to you within 24 hours.
                    </p>
                    <Button onClick={() => setView('dashboard')}>
                        Back to Home
                    </Button>
                </div>
            </div>
        );
    }

    return (
        <div className="p-4 pt-0 mb-16">
            {/* Emergency Contact */}
            <div className="bg-white p-4 rounded-xl shadow-sm border border-gray-100 mb-6">
                <p className="font-medium text-gray-800">Need immediate assistance?</p>
                <a
                    href="tel:+911234567890"
                    className="text-[#01a499] font-bold text-lg block mt-1"
                >
                    {contact}
                </a>
                <p className="text-xs text-gray-500 mt-1">
                    Available 9 AM - 7 PM, Monday to Saturday
                </p>
            </div>

            {/* Contact Form */}
            <form onSubmit={handleSubmit} className="space-y-4">
                {['name', 'phone', 'email', 'subject', 'message'].map(field => (
                    <div key={field}>
                        <label className="block text-sm font-medium text-gray-700 mb-1 capitalize">
                            {field}
                        </label>
                        {field === 'message' ? (
                            <textarea
                                name={field}
                                value={formData[field]}
                                onChange={handleChange}
                                placeholder="How can we help you?"
                                required
                                rows={4}
                                className="w-full p-3 border border-gray-300 rounded-lg focus:border-[#01a499]"
                            />
                        ) : (
                            <input
                                type={field === 'email' ? 'email' : field === 'phone' ? 'tel' : 'text'}
                                name={field}
                                value={formData[field]}
                                onChange={handleChange}
                                placeholder={`Enter your ${field}`}
                                required
                                className="w-full p-3 border border-gray-300 rounded-lg focus:border-[#01a499]"
                            />
                        )}
                    </div>
                ))}

                {error && (
                    <div className="p-3 bg-red-100 text-red-700 rounded-lg">
                        {error}
                    </div>
                )}

                <div className="fixed bottom-16 left-0 right-0 p-4 bg-white border-t">
                    <Button type="submit" disabled={isSubmitting}>
                        {isSubmitting ? 'Sending...' : 'Send Message'}
                    </Button>
                </div>
            </form>
        </div>
    );
};
